<template>  
  <div class="wrapper">
    <div>
      <h1 class="title is-1 is-white">404</h1>
    </div>
    <div>
      <h1 class="title is-1 is-white">PAGE NOT FOUND :(</h1>
    </div>
      <router-link :to="'/'" class="title is-5 is-white m-t-50">Return to <span class="is-underlined">Homepage</span>? </router-link :to="'/'">    
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
  .wrapper {
    min-height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// PageNotFound.vue?52129b3b